import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios'; // Убедитесь, что axios установлен
import { ArrowLeft, Loader2 } from 'lucide-react';

const DocumentViewer = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDoc = async () => {
      try {
        // Запрашиваем документы с сервера (где они уже отформатированы)
        const response = await axios.get('/api/legal-documents');
        const docs = response.data;

        // Ищем нужный документ по ID
        const foundDoc = docs.find(d => d.id === id);
        
        if (foundDoc) {
          setDoc(foundDoc);
        } else {
          setError("Документ не найден");
        }
      } catch (err) {
        console.error("Ошибка загрузки документов:", err);
        setError("Ошибка связи с сервером");
      } finally {
        setLoading(false);
      }
    };

    fetchDoc();
  }, [id]);

  if (loading) {
    return (
      <div className="min-h-screen bg-tg-bg flex items-center justify-center text-tg-hint">
        <Loader2 className="animate-spin" />
      </div>
    );
  }

  if (error || !doc) {
    return (
      <div className="min-h-screen bg-tg-bg flex flex-col items-center justify-center text-tg-hint p-4">
        <p className="mb-4">{error || "Документ не найден"}</p>
        <button onClick={() => navigate(-1)} className="text-tg-button font-bold">
          Назад
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-tg-bg text-tg-text">
      {/* HEADER */}
      <div className="px-4 pb-4 pt-tg flex items-center sticky top-0 bg-tg-bg/95 backdrop-blur-md z-10 border-b border-gray-100/5">
        <button onClick={() => navigate(-1)} className="mr-3 text-tg-text p-1 active:opacity-50">
          <ArrowLeft />
        </button>
        <h1 className="text-sm font-bold truncate pr-4">{doc.title}</h1>
      </div>

      {/* CONTENT */}
      {/* dangerouslySetInnerHTML нужен, так как с сервера приходит HTML (теги <p>, <strong>) */}
      <div 
        className="p-6 pb-24 whitespace-pre-wrap leading-relaxed text-sm text-tg-text/90 legal-content"
        dangerouslySetInnerHTML={{ __html: doc.content }}
      />
    </div>
  );
};

export default DocumentViewer;
